import Icon from "@atlaskit/icon";
import type { CustomGlyphProps } from "@atlaskit/icon/types";

const PriorityMinor24Glyph = (props: CustomGlyphProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={props["data-testid"]}
        className={props.className}
    >
        <path
            d="M18.4491 14.975C18.6764 14.8427 18.9468 14.8054 19.2015 14.871C19.4563 14.9367 19.6749 15.1001 19.81 15.3258C19.9451 15.5516 19.9858 15.8214 19.9233 16.077C19.8608 16.3325 19.7001 16.5531 19.4761 16.691L12.5061 20.864C12.3503 20.9571 12.1722 21.0062 11.9908 21.0058C11.8093 21.0055 11.6314 20.9557 11.4761 20.862L4.57005 16.69C4.34303 16.5529 4.17977 16.3312 4.11619 16.0737C4.05262 15.8162 4.09393 15.544 4.23105 15.317C4.36817 15.09 4.58986 14.9267 4.84734 14.8631C5.10483 14.7996 5.37703 14.8409 5.60405 14.978L11.9951 18.84L18.4491 14.976V14.975Z"
            fill="#388BFF"
        />
        <path
            d="M11.9951 12.837L18.4491 8.97197C18.6764 8.83969 18.9468 8.80233 19.2015 8.868C19.4563 8.93367 19.6749 9.09707 19.81 9.3228C19.9451 9.54853 19.9858 9.8184 19.9233 10.0739C19.8608 10.3295 19.7001 10.5501 19.4761 10.688L12.5061 14.862C12.3503 14.9551 12.1722 15.0041 11.9908 15.0038C11.8093 15.0034 11.6314 14.9537 11.4761 14.86L4.57005 10.686C4.34303 10.5489 4.17977 10.3272 4.11619 10.0697C4.05262 9.81219 4.09393 9.54 4.23105 9.31297C4.36817 9.08595 4.58986 8.92269 4.84734 8.85911C5.10483 8.79554 5.37703 8.83685 5.60405 8.97397L11.9951 12.837Z"
            fill="#388BFF"
        />
        <path
            d="M11.9951 6.82306L18.4491 2.95806C18.5618 2.88868 18.6872 2.84237 18.8179 2.82182C18.9487 2.80127 19.0822 2.80688 19.2108 2.83833C19.3394 2.86978 19.4604 2.92644 19.5669 3.00503C19.6734 3.08362 19.7633 3.18257 19.8313 3.29615C19.8992 3.40973 19.944 3.53567 19.9629 3.66668C19.9818 3.79768 19.9746 3.93114 19.9415 4.05932C19.9085 4.18749 19.8503 4.30783 19.7704 4.41336C19.6905 4.51889 19.5905 4.6075 19.4761 4.67406L12.5061 8.84806C12.3503 8.9412 12.1722 8.99022 11.9908 8.98987C11.8093 8.98952 11.6314 8.93981 11.4761 8.84606L4.57005 4.67206C4.34303 4.53494 4.17977 4.31326 4.11619 4.05577C4.05262 3.79828 4.09393 3.52609 4.23105 3.29906C4.36817 3.07203 4.58986 2.90878 4.84734 2.8452C5.10483 2.78163 5.37703 2.82294 5.60405 2.96006L11.9951 6.82306Z"
            fill="#388BFF"
        />
    </svg>
);

export const PriorityMinor24Icon = ({ label }: { label: string }) => {
    return <Icon glyph={PriorityMinor24Glyph} label={label} />;
};
